import { DefaultLayout, WebLayout } from "../layouts";
import Dashboard from "../pages/Dashboard/Dashboard";
import ViewOrganization from "../pages/Organization/ViewOrganization";
import UserOrganizations from "../pages/UserPages/UserOrganizations/UserOrganizations";
import Homepage from "../layouts/Homepage";
import Budgets from "../pages/Budget/Budget";
import UserList from "../pages/Users/UserList";
import Reports from "../pages/Reports/Reports";
import DataElements from "../pages/DataElements/DataElements";
import ConfirmDeleteModal from "../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";
import ImageSelect from "../components/Comman/ImageSelect/ImageSelect";
import SubmissionStatus from "../pages/SubmissionStatus/SubmissionStatus";
import DataReviewListing from "../pages/DataReview/DataReviewListing";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "../pages/AboutUs/AboutUs";
import Setting from "../pages/Settings/Setting";
import ViewDataElements from "../pages/DataElements/ViewDataElements";
import ViewUser from "../pages/Users/ViewUser";
import AssignElements from "../pages/LeaderAssignElements/AssignElements";
import UserDataEntries from "../pages/UserPages/UserDataEntries";
import { Updateaccountdetails } from "../pages/Acount/Updateaccountdetails";

export const globalControllerRoutes = [
  {
    path: "/",
    exact: true,
    layout: WebLayout,
    component: Homepage,
  },
  {
    path: "/controller/dashboard",
    exact: true,
    layout: DefaultLayout,
    component: Dashboard,
  },
  {
    path: "/controller/budgets",
    exact: true,
    layout: DefaultLayout,
    component: Budgets,
  },
  {
    path: "/controller/users",
    exact: true,
    layout: DefaultLayout,
    component: UserList,
  },
  {
    path: "/controller/view-organization/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewOrganization,
  },
  {
    path: "/controller/organizations",
    exact: true,
    layout: DefaultLayout,
    component: UserOrganizations,
  },

  {
    path: "/controller/reports",
    exact: true,
    layout: DefaultLayout,
    component: Reports,
  },
  {
    path: "/controller/data-elements",
    exact: true,
    layout: DefaultLayout,
    component: DataElements,
  },
  {
    path: "/controller/modal",
    exact: true,
    layout: DefaultLayout,
    component: ConfirmDeleteModal,
  },
  {
    path: "/controller/select",
    exact: true,
    layout: DefaultLayout,
    component: ImageSelect,
  },
  {
    path: "/controller/submission-status",
    exact: true,
    layout: DefaultLayout,
    component: SubmissionStatus,
  },
  {
    path: "/controller/data-review",
    exact: true,
    layout: DefaultLayout,
    component: DataReviewListing,
  },
  {
    path: "/privacy",
    exact: true,
    layout: DefaultLayout,
    component: PrivacyPolicy,
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    layout: DefaultLayout,
    component: AboutUs,
  },

  {
    path: "/settings",
    exact: true,
    layout: DefaultLayout,
    component: Setting,
  },
  {
    path: "/controller/view/data-element/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewDataElements,
  },
  {
    path: "/controller/view/user/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewUser,
  },
  {
    path: "/controller/assign-element",
    exact: true,
    layout: DefaultLayout,
    component: AssignElements,
  },
  {
    path: "/controller/data-entry",
    exact: true,
    layout: DefaultLayout,
    component: UserDataEntries,
  },
  {
    path: "/profile",
    exact: true,
    layout: DefaultLayout,
    component: Updateaccountdetails,
  },
];
